import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthShell from "../components/AuthShell";
import { Button, Field, Spinner } from "../components/ui/kit";
import { useAuth } from "../context/AuthContext";
import { apiError } from "../lib/api";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ company_name: "", name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(form);
      nav("/");
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Registrace firmy"
      subtitle="Založ účet a 14 dní vyzkoušej ProfitPilot zdarma."
      footer={
        <>
          Už máš účet?{" "}
          <Link to="/login" className="text-accent font-600 hover:text-accent-hover">
            Přihlas se
          </Link>
        </>
      }
    >
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <Field label="Název firmy">
          <input className="field" value={form.company_name} onChange={upd("company_name")}
            placeholder="Klimatop s.r.o." data-testid="register-company" required />
        </Field>
        <Field label="Tvé jméno">
          <input className="field" value={form.name} onChange={upd("name")}
            placeholder="Martin Král" data-testid="register-name" required />
        </Field>
        <Field label="E-mail">
          <input type="email" className="field" value={form.email} onChange={upd("email")}
            placeholder="jmeno@firma.cz" data-testid="register-email" required />
        </Field>
        <Field label="Heslo" hint="Alespoň 10 znaků, písmena i číslice.">
          <input type="password" className="field" value={form.password} onChange={upd("password")}
            placeholder="••••••••••" data-testid="register-password" required />
        </Field>
        {error && (
          <div className="text-[12.5px] text-danger bg-[#fdecea] rounded-input px-3 py-2" data-testid="register-error">
            {error}
          </div>
        )}
        <Button className="w-full justify-center" disabled={loading} data-testid="register-submit">
          {loading ? <Spinner /> : "Založit firmu"}
        </Button>
      </form>
    </AuthShell>
  );
}
